import { Component, inject, OnInit } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { UserService } from '../_service/user.service';
import { AuthService } from '../_service/auth.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-user-mgt',
  standalone: true,
  imports: [NgbModule, FormsModule, CommonModule],
  templateUrl: './user-mgt.component.html',
  styleUrl: './user-mgt.component.scss'
})
export class UserMgtComponent implements OnInit {
  userService = inject(UserService)
  auth = inject(AuthService)
  router = inject(Router)

  // Make Math available in template
  Math = Math;

  userDetails!: any;
  users: any;
  page = 1
  size = 0
  pageSize = 1
  page2 = 10
  search: any = ''
  filter: any = ''
  status: any = '';
  selectedRole: string = '';
  selectedStatus: string = '';

  // Loading states
  isLoadingUsers: boolean = false;
  isSearching: boolean = false;
  isFiltering: boolean = false;
  updatingStatusId: string | null = null;
  searchTimeout: any;

  ngOnInit(): void {
    this.userDetails = (this.userService.user)
    this.getUsers()
  }
  getUsers() {
    this.isLoadingUsers = true;
    this.userService.getUsers(this.page).subscribe({
      next: (res: any) => {
        this.users = res.data
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
        console.log('Users', res)
      },
      error: (err: any) => {
        console.log(err)
        Swal.fire('Error', 'Failed to load users', 'error')
      },
      complete: () => {
        this.isLoadingUsers = false;
      }
    })
  }
  onSearch() {
    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.isSearching = true;
    this.searchTimeout = setTimeout(() => {
      this.userService.getUsers(this.page, this.search).subscribe({
        next: (res: any) => {
          this.users = res.data
          const meta = res.meta
          this.size = meta.total
          this.pageSize = meta.per_page
          console.log('Users', res)
        },
        error: (err: any) => {
          console.log(err)
          Swal.fire('Error', 'Search failed', 'error')
        },
        complete: () => {
          this.isSearching = false;
        }
      })
    }, 500); // Reduced timeout for better UX
  }
  viewBalance(id: any) {
    // alert('test')
    this.router.navigateByUrl(`/admin/waiter/waiter_details/${id}`)
  }
  capitalizeFirstLetter(sentence: string) {
    if (!sentence) return sentence; // Check if the sentence is empty or undefined
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  // Helper methods for template calculations
  getTotalPages(): number {
    return Math.ceil(this.size / this.pageSize) || 1;
  }

  getEndEntry(): number {
    return Math.min(this.page * this.pageSize, this.size);
  }
  Filter(filter: any) {
    this.selectedRole = filter;
    this.filter = filter;
    this.isFiltering = true;

    this.userService.getUsers(this.page, this.search, this.filter, this.status).subscribe({
      next: (res: any) => {
        this.users = res.data
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
        console.log('Users', res)
      },
      error: (err: any) => {
        console.log(err)
        Swal.fire('Error', 'Filter failed', 'error')
      },
      complete: () => {
        this.isFiltering = false;
      }
    })
  }

  clearFilter() {
    this.page = 1
    this.search = ''
    this.filter = null
    this.status = null
    this.selectedRole = '';
    this.selectedStatus = '';
    this.getUsers()
  }
  statuusFilter(status: any) {
    this.selectedStatus = status;
    this.status = status;
    this.isFiltering = true;

    this.userService.getUsers(this.page, this.search, this.filter, this.status).subscribe({
      next: (res: any) => {
        this.users = res.data
        const meta = res.meta
        this.size = meta.total
        this.pageSize = meta.per_page
        console.log('Users', res)
      },
      error: (err: any) => {
        console.log(err)
        Swal.fire('Error', 'Status filter failed', 'error')
      },
      complete: () => {
        this.isFiltering = false;
      }
    })
  }
  refresh(event: any) {
    this.page = event
    this.getUsers()
  }
  createuser() {
    this.router.navigateByUrl('/admin/user/create_new_user')
  }
  edit(id: any) {
    // alert('test')
    this.router.navigateByUrl(`/admin/user/edit_user/${id}`)
  }


  updateStatus(id: any) {
    this.updatingStatusId = id;

    Swal.fire({
      title: 'Are you sure?',
      text: 'This will change the user status',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#00a859',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, update it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.userService.updateStatus(id).subscribe({
          next: (res) => {
            Swal.fire('Success', 'Status updated successfully', 'success')
          },
          error: (err) => {
            Swal.fire('Failed', err.error.message, 'error')
          },
          complete: () => {
            this.updatingStatusId = null;
            this.getUsers()
          }
        })
      } else {
        this.updatingStatusId = null;
      }
    })
  }
}

// email: "ayodejieluwande@gmail.com"
// first_name: "Ayo"
// id: 6
// last_name: "Elu"
// phone: "08089932753"
// roles: Array["admin"]
